import { render, staticRenderFns } from "./booksList.vue?vue&type=template&id=4c82938d&scoped=true&"
import script from "./booksList.vue?vue&type=script&lang=js&"
export * from "./booksList.vue?vue&type=script&lang=js&"
import style0 from "./booksList.vue?vue&type=style&index=0&id=4c82938d&lang=scss&scoped=true&"
import style1 from "./booksList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82938d",
  null
  
)

export default component.exports